module.exports = __webpack_public_path__ + "static/media/checkoutbg_right_normal.f6c804f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/checkout-navbar/progress-bullet/checkoutbg_right_normal.svg
// module id = 700
// module chunks = 0